export type LOOKUP_TABLE_DETAILED_FORM_FIELDS = 'string' | 'number' | 'boolean';
export type LookupTableDetailedFormFieldType = 'string' | 'number' | 'boolean';
